import React, { useEffect } from 'react';
import { IoChatbubbleEllipses, IoPersonAdd, IoCheckmarkDone, IoNotificationsOffOutline } from "react-icons/io5";
import { useSocket } from '../socket/SocketContext';
import { useLanguage } from '../i18n/LanguageContext';

const iconFor = (type) => {
  if (type === 'friendRequest') return <IoPersonAdd />;
  if (type === 'friendAccepted') return <IoCheckmarkDone />;
  return <IoChatbubbleEllipses />;
};

const timeAgo = (iso, t) => {
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return t('notifications.justNow');
  if (mins < 60) return t('notifications.minutesAgo', { count: mins });
  const hours = Math.floor(mins / 60);
  if (hours < 24) return t('notifications.hoursAgo', { count: hours });
  const days = Math.floor(hours / 24);
  return t('notifications.daysAgo', { count: days });
};

export default function Notifications() {
  const { notifications, markNotificationsRead } = useSocket();
  const { t } = useLanguage();

  useEffect(() => {
    markNotificationsRead();
  }, [markNotificationsRead]);

  return (
    <>
      <div className="PageContainer">
        <div className="PageHeader glass">
          <h4>{t('notifications.title')}</h4>
          <aside className="descGray">{t('notifications.subtitle')}</aside>
        </div>
        <div className="Page glass">
          <ul className="NotificationList">
            {notifications.length === 0 &&
              <div className="EmptyState">
                <IoNotificationsOffOutline />
                <p className="descGray">{t('notifications.empty')}</p>
              </div>
            }
            {notifications.map((n) => (
              <li key={n.id} className="glassCard">
                <div className="NotifIcon">{iconFor(n.type)}</div>
                <div className="ChCon">
                  <b>{n.text}</b>
                  <aside className="descGray">{timeAgo(n.timestamp, t)}</aside>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
